import React from 'react';

const En = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_46_37)">
        <path d="M16.0003 0H0V16.0003H16.0003V0Z" fill="#000066" />
        <path
          d="M0 0V1.78889L14.2115 16.0004H16.0003V14.2115L1.78884 5.33344e-05L0 0ZM16.0003 0V1.78884L1.78884 16.0003H0V14.2115L14.2115 0H16.0003Z"
          fill="white"
        />
        <path
          d="M6.6668 0V16.0003H9.33352V0H6.6668ZM0 5.33344V10.6669H16.0003V5.33344H0Z"
          fill="white"
        />
        <path
          d="M0 6.40013V9.60019H16.0003V6.40013H0ZM7.20014 0V16.0003H8.80018V0H7.20014Z"
          fill="#CC0000"
        />
        <path
          d="M0 16.0003L5.33344 10.6669H6.526L1.19256 16.0003H0ZM0 0L5.33344 5.33344H4.14088L0 1.19261L0 0ZM9.47432 5.33344L14.8078 0H16.0003L10.6669 5.33344H9.47432ZM16.0003 16.0003L10.6669 10.6669H11.8594L16.0003 14.8078V16.0003Z"
          fill="#CC0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_46_37">
          <rect width="16" height="16" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default En;
